import { useEffect, useState } from 'react';
import { FiSettings, FiX } from 'react-icons/fi';
import { useLclSettings } from '../hooks/useLclSettings';

const FIELDS = [
  { key: 'ics_new',        label: 'ICS actuel (nouveau portail)', placeholder: 'FR11ZZZ123702' },
  { key: 'ics_old',        label: 'ICS ancien',                   placeholder: 'FR08ZZZ8698E7' },
  { key: 'bank_code',      label: 'Code Banque',                  placeholder: '30002' },
  { key: 'branch_code',    label: 'Code Guichet',                 placeholder: '00550' },
  { key: 'account_number', label: 'N° de compte',                 placeholder: '00000000000' },
  { key: 'iban_creancier', label: 'IBAN créancier',               placeholder: 'FR76…' },
];

export default function LclSettingsModal({ open, onClose }) {
  const { data, save } = useLclSettings();
  const [form, setForm] = useState({});

  useEffect(() => { if (data) setForm(data); }, [data]);

  if (!open) return null;

  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const onSubmit = async () => {
    const ok = await save(form);
    if (ok) onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded shadow-xl border border-gray-200 w-full max-w-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-3 py-2 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <FiSettings className="h-4 w-4 text-blue-600" />
            <div className="text-sm font-bold text-gray-900">Configuration créancier LCL</div>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <FiX className="h-4 w-4" />
          </button>
        </div>

        <div className="px-3 py-3 space-y-2">
          {FIELDS.map((f) => (
            <div key={f.key}>
              <label className="block text-[10px] font-semibold text-gray-500 uppercase tracking-wider mb-0.5">
                {f.label}
              </label>
              <input
                type="text"
                value={form[f.key] ?? ''}
                onChange={onChange(f.key)}
                placeholder={f.placeholder}
                className="w-full px-2 py-1 text-[11px] font-mono border border-gray-200 rounded
                           focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          ))}

          <div className="mt-3 pt-2 border-t border-gray-100 grid grid-cols-2 gap-2 text-[10px] text-gray-500">
            <div>
              <div className="uppercase font-semibold tracking-wider">Séquence mandats</div>
              <div className="text-gray-800 font-mono">#{data?.next_mandate_sequence ?? '—'}</div>
            </div>
            <div>
              <div className="uppercase font-semibold tracking-wider">Séquence CSV</div>
              <div className="text-gray-800 font-mono">#{data?.next_csv_sequence ?? '—'}</div>
            </div>
            <div>
              <div className="uppercase font-semibold tracking-wider">Séquence CFONB</div>
              <div className="text-gray-800 font-mono">#{data?.next_cfonb_sequence ?? '—'}</div>
            </div>
            <div className="col-span-2">
              <div className="uppercase font-semibold tracking-wider">Dernière maj</div>
              <div className="text-gray-800">
                {data?.updated_at ? new Date(data.updated_at).toLocaleString('fr-FR') : '—'}
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2 px-3 py-2 bg-gray-50 border-t border-gray-100 rounded-b">
          <button
            onClick={onClose}
            className="px-2.5 py-1.5 rounded text-[11px] font-medium text-gray-600 border border-gray-200 hover:bg-white"
          >
            Annuler
          </button>
          <button
            onClick={onSubmit}
            className="px-2.5 py-1.5 rounded text-[11px] font-semibold text-white bg-blue-600 hover:bg-blue-700"
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}
